app.views.preregistration = app.views.base.extend({
  childEvents: {
    'click [data-accordion="trigger"]': 'onChangeAuthTypeEventListener',
    'click [data-confirm]': 'onCheckTermsConditionsEventListener',
    'click [data-show]': 'onShowPasswordEventListener',
    'change [data-input]': 'onFormFieldChangeEventListener',
    'keyup [data-dob]': 'onDateEntryEventListener'
  },
  constants: {
    defaultError: 'Please correct error(s).'
  },
  attr: {
    form: 'data-form',
    input: 'data-input',
    submit: 'data-submit',
    message: 'data-message',
    error: 'data-error',
    dob: 'data-dob',
    spinner: 'data-spinner',
    confirm: 'data-confirm',
    accordion: 'data-accordion',
    accordionItem: 'data-accordion-item'
  },
  classes: {
    active: 'active',
    disabled: 'disabled',
    preRegistrationError: 'pre-registration-error',
    inputError: 'input-validation-error',
    fieldError: 'field-validation-error',
    fieldValid: 'field-validation-valid'
  },
  /**
   * Initialise Registration View Listener
   * @public
   * @constructor
   * @param {data} data : RegistrationViewModel
   */

  init: function init(data) {},
  /**
   * Change Authentiaction Type Event Listener
   * Fires when the user selects a different authentiaction type from the homepage.
   * @public
   * @param {event} e : event of the input field change.
   */

  onChangeAuthTypeEventListener: function onChangeAuthTypeEventListener(e) {
    var forms = $('[' + this.attr.form + ']');
    this._clearInputValues(forms);
    this._disableSubmissionAction();
    this._clearErrorMessages();
    this._setActiveAuthType(e);
  },
  /**
   * Check Terms and Conditions Event Listener
   * Fires when the user checks or unchecks the 'Terms and Conditions' checkbox.
   * @public
   * @param {event} e : event of the input field change.
   */

  onCheckTermsConditionsEventListener: function onCheckTermsConditionsEventListener(e) {
    this._updateSubmitActionState();
  },
  /**
   * Form Field Change Event Listener
   * Fires when the user enters or changes the information in the form fields.
   * @public
   * @param {event} e : event of the input field change.
   */

  onFormFieldChangeEventListener: function onFormFieldChangeEventListener(e) {
    this._updateSubmitActionState();
    this._updateFormErrorState(e);
    if ($(e.currentTarget).is('[' + this.attr.dob + ']')) {
      this._validateDateOfBirth(e);
    }
  },
  /**
   * Date Entry Event Listener
   * Formats the date when the user enters there date of birth.
   * @public
   * @param {event} e : event of the input field key up.
   */

  onDateEntryEventListener: function onDateEntryEventListener(e) {
    if (!e.ctrlKey && !e.metaKey && (e.keyCode === 32 || e.keyCode > 46)) {
      app.helpers.dateFormat(e.target);
    }
  },
  /**
   * On Show Password Event Listener
   * Fires when the user click to show the password in visible text.
   * @public
   * @param {event} e : the event of the show action.
   */

  onShowPasswordEventListener: function onShowPasswordEventListener(e) {
    var input = $(e.currentTarget).parents('.input').find('[' + this.attr.input + ']');
    if (input.attr('type') === 'password') {
      $(e.currentTarget).html('Hide');
      input.attr('type', 'text');
    } else {
      $(e.currentTarget).html('Show');
      input.attr('type', 'password');
    }
  },
  /**
   * On Authentication Request Success
   * Redirects the user to the accounts page on successfull authentication.
   * @public
   * @param {object} response : the response object containing the redurect url.
   */

  onAuthenticationRequestSuccess: function onAuthenticationRequestSuccess(response) {
    if (response && response.nextRequestAjax === false) {
      $('[' + this.attr.spinner + ']').show();
      window.location = window.location.origin + response.redirectUrl;
    }
  },
  /**
   * On Complete Form Submission
   * Fires when the authentication form AJAX submission has been completed.
   * @public
   * @param {element} form : the submitted form.
   */

  onCompleteFormSubmission: function onCompleteFormSubmission(form) {
    var formError = $(form).parents('[' + this.attr.accordionItem + ']').find('.' + this.classes.preRegistrationError);
    var validationContainer = $(form).find('[' + this.attr.message + ']');
    var validationMessage = validationContainer.find('li').html();
    if (validationMessage) {
      formError.find('[' + this.attr.error + ']').html(validationMessage);
      formError.show();
    } else {
      formError.find('[' + this.attr.error + ']').html('');
      formError.hide();
    }
  },
  /**
   * Update Submit Action State
   * Enables or disables the submit action based on the field state and wether the terms and conditions have been confirmed.
   * @private
   */

  _updateSubmitActionState: function _updateSubmitActionState() {
    var form = $('[' + this.attr.form + '="true"]');
    var emptyFields = this._getEmptyFieldCount(form);
    var confirm = $('[' + this.attr.confirm + ']');
    if (emptyFields > 0) {
      this._disableSubmissionAction();
    } else {
      if (confirm.length && !confirm.is(':checked')) {
        this._disableSubmissionAction();
      } else {
        this._enableSubmissionAction();
      }
    }
  },
  /**
   * Update Form Error State
   * Checks against all inputs within the form to see if the form error message is required.
   * @private
   * @param {event} e : the event of the input field change.
   */

  _updateFormErrorState: function _updateFormErrorState(e) {
    var _this = this;
    var form = $('[' + this.attr.form + '="true"]');
    setTimeout(function () {
      var inputErrors = form.find('.' + _this.classes.inputError).length;
      var error = $(e.currentTarget).parents('[' + _this.attr.accordionItem + ']').find('[' + _this.attr.error + ']');
      var formError = error.parents('.' + _this.classes.preRegistrationError);
      if (inputErrors > 0) {
        error.html(_this.constants.defaultError);
        formError.show();
      } else {
        formError.hide();
      }
    }, 0);
  },
  /**
   * Get Empty Field Count
   * Returns the length of empty fields on the active authentication form.
   * @private
   * @param {element} form : the active authentication form.
   */

  _getEmptyFieldCount: function _getEmptyFieldCount(form) {
    var inputs = form.find('[' + this.attr.input + ']');
    var emptyFields = inputs.filter(function () {
      return this.value === ''; // Find all empty inputs within the form.
    });
    return emptyFields.length;
  },
  /**
   * Set Active Authentication Type
   * Sets the required state for the new authentication type selected from the homepage.
   * @private
   * @param {event} e : the event of the accordion selection.
   */

  _setActiveAuthType: function _setActiveAuthType(e) {
    var content = $(e.currentTarget).next('[' + this.attr.accordion + '="content"]');
    var previousForm = $('[' + this.attr.form + '="true"]');
    var form = content.find('[' + this.attr.form + ']');
    var type = form.attr('id');
    var submit = $('[' + this.attr.submit + ']');
    previousForm.attr(this.attr.form, false); // Set the previous active form to inactive.
    form.attr(this.attr.form, true); // Set the form within the selected accordion row to active.
    submit.attr('form', type); // Update the submit form id with the id of the active form.
  },
  /**
   * Clear Input Values
   * Clears the values from all input fields.
   * @private
   * @param {element} forms : all authentication forms.
   */

  _clearInputValues: function _clearInputValues(forms) {
    forms.find('[' + this.attr.input + ']').each(function () {
      $(this).val('');
    });
  },
  /**
   * Clear Error Messages
   * Clears the form validation messages.
   * @private
   */

  _clearErrorMessages: function _clearErrorMessages() {
    var formError = $('[' + this.attr.error + ']').parents('.' + this.classes.preRegistrationError);
    var inputError = $('.' + this.classes.inputError);
    var fieldError = $('.' + this.classes.fieldError);
    formError.hide();
    inputError.removeClass(this.classes.inputError);
    fieldError.removeClass(this.classes.fieldError);
    fieldError.addClass(this.classes.fieldValid);
  },
  /**
   * Validate Date of Birth
   * Validates that the entered date of birth is a valid date and is not in the future.
   * @private
   * @param {event} e : the events of the data of birth input field.
   */

  _validateDateOfBirth: function _validateDateOfBirth(e) {
    var _this = this;
    var input = $(e.currentTarget);
    var today = moment();
    var date = moment(input.val(), 'DD/MM/YYYY');
    if (input.val() !== '' && date.isValid() && date.isBefore(today)) return;
    setTimeout(function () {
      input.addClass(_this.classes.inputError);
      input.next('.' + _this.classes.fieldValid).html('<span>Please enter a valid date of birth.</span>');
      input.next('.' + _this.classes.fieldValid).addClass(_this.classes.fieldError);
      input.next('.' + _this.classes.fieldValid).removeClass(_this.classes.fieldValid);
      _this._updateFormErrorState(e);
    }, 0);
  },
  /**
   * Enable Submit Action
   * Enables the form submit action allowing for the form to be submitted.
   * @private
   */

  _enableSubmissionAction: function _enableSubmissionAction() {
    var submit = $('[' + this.attr.submit + ']');
    submit.prop('disabled', false);
    submit.removeClass('btn--' + this.classes.disabled);
  },
  /**
   * Disable Submit Action
   * Disables the submit action blocking the form from being submitted.
   * @private
   */

  _disableSubmissionAction: function _disableSubmissionAction() {
    var submit = $('[' + this.attr.submit + ']');
    submit.prop('disabled', true);
    submit.addClass('btn--' + this.classes.disabled);
  }
});